module.exports = __webpack_public_path__ + "static/media/UPI.ca875468.svg";